export const EYE_COLOR = [
  "Blue",
  "Light Blue",
  "Dark Blue",
  "Brown",
  "Light Brown",
  "Dark Brown",
  "Green",
  "Hazel",
  "Grey",
  "Amber",
  "Black",
] as const;
